"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.YouTubeIframeLoader = void 0;
/**
 * @type {{loaded: boolean, listeners: *[], load: YouTubeIframeLoader.load, src: string, loading: boolean, done: YouTubeIframeLoader.done}}
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Alexander Prinzhorn <alexander@prinzhorn.it>
 *
 * @see https://www.npmjs.com/package/youtube-iframe
 */
exports.YouTubeIframeLoader = {
    src: 'https://www.youtube.com/iframe_api',
    loading: false,
    loaded: false,
    listeners: [],
    load: function (callback) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const _this = this;
        this.listeners.push(callback);
        if (this.loaded) {
            setTimeout(function () {
                _this.done();
            });
            return;
        }
        if (this.loading)
            return;
        this.loading = true;
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        window.onYouTubeIframeAPIReady = function () {
            _this.loaded = true;
            _this.done();
        };
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.src;
        document.body.appendChild(script);
    },
    done: function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        delete window.onYouTubeIframeAPIReady;
        while (this.listeners.length) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            this.listeners.pop()(window.YT);
        }
    }
};
//# sourceMappingURL=youtube-iframe-loader.js.map